// extracted by mini-css-extract-plugin
export default {"root":"ci25n","heading-and-description":"_2G3_M","headingAndDescription":"_2G3_M","content":"k5MDL"};